import { useState } from "react";
import PageHeader from "../components/pageHeader";
import { useTranslation } from "../../../i18n/useTranslation";
import { submitForm } from "../../../api/submitForm";
import Honeypot from "../../../components/honeypot";
import { useFormTiming } from "../../../components/useFormTiming";

const Contact = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.contact");
  const [form, setForm] = useState({ name: "", company: "", email: "", message: "" });
  const [hp, setHp] = useState("");
  const startedAt = useFormTiming();
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [error, setError] = useState("");

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    const result = await submitForm(
      "contact",
      "deviceworks",
      { name: form.name, company: form.company, email: form.email, message: form.message },
      { hp, startedAt }
    );
    if (result.ok) {
      setStatus("sent");
    } else {
      setStatus("error");
      setError(result.error);
    }
  };

  return (
    <div>
      <PageHeader eyebrow={h.eyebrow} title={h.title} />
      <div className="max-w-md mx-auto px-5 py-16">
        {status === "sent" ? (
          <p className="dw-mini text-center">Thanks — your message has been received.</p>
        ) : (
          <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
            <Honeypot value={hp} onChange={(e) => setHp(e.target.value)} />
            <input className="dw-field" placeholder="Name" required value={form.name} onChange={update("name")} />
            <input className="dw-field" placeholder="Company" value={form.company} onChange={update("company")} />
            <input type="email" className="dw-field" placeholder="Email" required value={form.email} onChange={update("email")} />
            <textarea className="dw-field" placeholder="Message" rows="4" required value={form.message} onChange={update("message")} />
            <button type="submit" className="dw-btn self-start mt-1" disabled={status === "sending"}>
              {status === "sending" ? "Sending…" : "Send"}
            </button>
            {status === "error" && <p className="dw-mini" style={{ color: "#e06666" }}>{error}</p>}
          </form>
        )}
      </div>
    </div>
  );
};

export default Contact;
